import { useQuery } from "@tanstack/react-query"
import { useEffect } from "react"
import { getQuests } from "@/lib/api/quests"
import { useQuestsStore } from "@/lib/store/quests"
import { queryKeys } from "@/lib/utils/query"
import { Journey, QuestsResponse } from "@/types/quests"

export const getQuestImageUrl = (imageUrl: string | null): string => {
  return imageUrl || "/images/default-image.jpg"
}

export const useQuests = (isAuthenticated: boolean, journeys: Journey[]) => {
  const {
    availableQuests,
    setAvailableQuests,
    upcomingQuests,
    setUpcomingQuests,
    loading: storeLoading,
    setLoading,
  } = useQuestsStore()

  const {
    data: questsData,
    isLoading: isLoadingQuests,
    error: questsError,
  } = useQuery<QuestsResponse>({
    queryKey: queryKeys.quests,
    queryFn: getQuests,
    enabled: isAuthenticated,
    staleTime: 1000 * 60 * 5,
    gcTime: 1000 * 60 * 10,
  })

  useEffect(() => {
    if (questsData?.results) {
      const activeQuestIds = new Set(
        journeys.map((journey) => journey.quest.id),
      )
      const quests = questsData.results
      const availableQuests = []
      const upcomingQuests = []
      for (const quest of quests) {
        if (quest.state == "PR") {
          upcomingQuests.push(quest)
        } else if (!activeQuestIds.has(quest.id) && quest.state == "AC") {
          availableQuests.push(quest)
        }
      }
      setAvailableQuests(availableQuests)
      setUpcomingQuests(upcomingQuests)
    }
  }, [questsData, journeys])

  useEffect(() => {
    setLoading(isLoadingQuests)
  }, [isLoadingQuests, setLoading])

  return {
    availableQuests,
    upcomingQuests,
    loading: storeLoading,
    error: questsError,
  }
}
